module.exports = __webpack_public_path__ + "img/x1.2898bcc2.png";